/**
 * Age check (date of birth) for airsoft items tagged "compliance".
 *
 * The store's validation function blocks cart adds and checkout for those products until the
 * cart attribute "Date of birth" exists. Fields are rendered by snippets/compliance-dob-field.liquid
 * and can be re-rendered by partial swaps (variant changes, cart drawer refreshes), so everything
 * here uses event delegation plus a MutationObserver instead of per-instance inline scripts.
 *
 * window.complianceDob.ensure(form) is awaited by s-product-form before it adds to cart: it
 * validates the field inside that form and waits until the attribute is saved to the cart.
 */
(function () {
  if (window.complianceDob) return;

  var MIN_AGE = 18;
  var ATTR = 'Date of birth';
  var pending = Promise.resolve();
  var savedValue = null;

  function persist(value) {
    pending = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR]: value } }),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart update rejected: ' + response.status);
      savedValue = value;
    });
    return pending;
  }

  function ageFrom(value) {
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return null;
    var now = new Date();
    var age = now.getFullYear() - Number(match[1]);
    var monthDelta = now.getMonth() + 1 - Number(match[2]);
    if (monthDelta < 0 || (monthDelta === 0 && now.getDate() < Number(match[3]))) age -= 1;
    return age;
  }

  function errorFor(input) {
    var value = input.value;
    if (!value) return input.dataset.msgRequired;
    var age = ageFrom(value);
    if (age === null || age > 120) return input.dataset.msgInvalid;
    if (age < MIN_AGE) return input.dataset.msgUnderage;
    return '';
  }

  function showError(input, message) {
    var root = input.closest('[data-compliance-dob]');
    var el = root && root.querySelector('[data-compliance-dob-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  // Keep every rendered copy (product page, drawer, cart page) in sync.
  function syncInputs(value, source) {
    document.querySelectorAll('[data-compliance-dob-input]').forEach(function (input) {
      if (input !== source && !input.value) input.value = value;
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-compliance-dob-input]')) return;
    var message = errorFor(input);
    showError(input, message);
    if (message) return;
    syncInputs(input.value, input);
    persist(input.value).catch(function () {
      showError(input, input.dataset.msgSave);
    });
  });

  async function ensure(form) {
    var input = form && form.querySelector('[data-compliance-dob-input]');
    if (!input) return true;
    var message = errorFor(input);
    if (message) {
      showError(input, message);
      input.focus();
      return false;
    }
    try {
      await pending.catch(function () {});
      if (savedValue !== input.value) await persist(input.value);
      showError(input, '');
      return true;
    } catch (error) {
      showError(input, input.dataset.msgSave);
      return false;
    }
  }

  var prefillRequested = false;
  function prefill(input) {
    if (prefillRequested || input.value) return;
    var root = input.closest('[data-compliance-dob]');
    if (!root || root.dataset.loggedIn !== 'true') return;
    prefillRequested = true;
    fetch('/apps/verify/prefill', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.dob || input.value) return;
        input.value = data.dob;
        syncInputs(data.dob, input);
        return persist(data.dob);
      })
      .catch(function () { /* fails open: the buyer types the date */ });
  }

  var staleCleared = false;
  function scan() {
    document.querySelectorAll('[data-compliance-dob-input]').forEach(function (input) {
      if (!input.value && savedValue) input.value = savedValue;
      prefill(input);
    });
    if (!staleCleared && document.querySelector('[data-compliance-dob-stale]') && !document.querySelector('[data-compliance-dob-input]')) {
      staleCleared = true;
      savedValue = null;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [ATTR]: '' } }),
        keepalive: true,
      }).catch(function () {});
    }
  }

  window.complianceDob = { ensure: ensure };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  var scanQueued = false;
  new MutationObserver(function () {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
